import React from "react";
import "./styles.scss";

import Button from "../../../common/button";
import { useNavigate } from "react-router-dom";
import { ReactComponent as PaymentFailIcon } from "../../../assets/icons/payment_fail.svg";

const PaymentFailed = ({ data }) => {
  const Navigate = useNavigate();
  return (
    <div className="payment-status-container">
      <>
        <PaymentFailIcon />
        <h3>{data?.payment_failed_text}</h3>
        <div
          dangerouslySetInnerHTML={{
            __html: data?.payment_failed_description,
          }}
        />
        <Button
          onClick={() => Navigate(`${process.env.REACT_APP_BASE}/checkout`)}
        >
          Go to payment
        </Button>
      </>
    </div>
  );
};

export default PaymentFailed;
